module.exports = __webpack_public_path__ + "static/img/clientapps.bde2bd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clientapps.svg
// module id = m8ch
// module chunks = 58